import { createContext, useContext } from 'react';

import type { PolicyBundle } from '@features/policy/policies.models';

export interface SideNavPopupData {
  path: string;
  friendlyPath: string;
}

export interface SideNavPopupDataById {
  artifacts?: SideNavPopupData | null;
  policy?: PolicyBundle[] | null;
}

export interface SideNavContextType {
  /**
   * Identifier of the nav item that should be marked as active.
   */
  activeItem: string;
  /**
   * Whether the sidebar is currently expanded or collapsed.
   */
  isExpanded: boolean;
  /**
   * Data to drive custom popup content
   */
  popupData: SideNavPopupDataById;
}

const SideNavContext = createContext<SideNavContextType>({
  activeItem: '',
  isExpanded: false,
  popupData: {
    artifacts: null,
    policy: null,
  },
});

export const useSideNavContext = () => useContext(SideNavContext);

export const SideNavProvider = SideNavContext.Provider;

export default SideNavProvider;
